export enum HTTPStatusGroup {
    Informational = 100,
    Success = 200,
    Redirection = 300,
    ClientErrors = 400,
    ServerErrors = 500,
}

